// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type DomainField = {
  key: string;
  type: string;
  label: string;
  required?: boolean | undefined;
  description?: string | undefined;
  placeholder?: string | undefined;
  options?: Array<{
  id?: string | undefined;
  label: string;
  color?: string | undefined;
}> | undefined;
  min?: number | undefined;
  max?: number | undefined;
};
export const DomainFieldSchema = z.object({
  key: z.string(),
  type: z.string(),
  label: z.string(),
  required: z.boolean().optional(),
  description: z.string().optional(),
  placeholder: z.string().optional(),
  options: z.array(z.object({
    id: z.string().optional(),
    label: z.string(),
    color: z.string().optional(),
  }).strict()).optional(),
  min: z.number().optional(),
  max: z.number().optional(),
}).strict();

export type DomainSubjectSchema = {
  labels: {
  singular: string;
  plural: string;
};
  fields: Array<DomainField>;
  unitsOf: string | null;
};
export const DomainSubjectSchemaSchema = z.object({
  labels: z.object({
    singular: z.string(),
    plural: z.string(),
  }).strict(),
  fields: z.array(DomainFieldSchema),
  unitsOf: z.string().nullable(),
}).strict();

export type DomainResponseSet = {
  key: string;
  name: string;
  options: Array<{
  id?: string | undefined;
  label: string;
  color?: string | undefined;
}>;
};
export const DomainResponseSetSchema = z.object({
  key: z.string(),
  name: z.string(),
  options: z.array(z.object({
    id: z.string().optional(),
    label: z.string(),
    color: z.string().optional(),
  }).strict()),
}).strict();

export type DomainPack = {
  key: string;
  name: string;
  icon: string | null;
  description: string;
  featureKey: string;
  order: number;
  active: boolean;
  subjectSchema: DomainSubjectSchema;
  vocabulary: Record<string, string>;
  starterTemplateIds: Array<string>;
  responseSetPresets: Array<DomainResponseSet>;
  reportDefaults: Record<string, unknown>;
  capture: Record<string, boolean>;
  agentGrounding: {
  tools: Array<string>;
};
};
export const DomainPackSchema = z.object({
  key: z.string(),
  name: z.string(),
  icon: z.string().nullable(),
  description: z.string(),
  featureKey: z.string(),
  order: z.number(),
  active: z.boolean(),
  subjectSchema: DomainSubjectSchemaSchema,
  vocabulary: z.record(z.string()),
  starterTemplateIds: z.array(z.string()),
  responseSetPresets: z.array(DomainResponseSetSchema),
  reportDefaults: z.record(z.unknown()),
  capture: z.record(z.boolean()),
  agentGrounding: z.object({
    tools: z.array(z.string()),
  }).strict(),
}).strict();

export type ListDomainsResponse = {
  data: Array<DomainPack>;
  defaultDomainKey: string;
};

export async function listDomains(): Promise<ListDomainsResponse> {
  const response = await api.get<ListDomainsResponse>(`/domains`);
  return response.data;
}

export const domainsKeys = {
  all: ["domains"] as const,
  lists: () => [...domainsKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...domainsKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...domainsKeys.all, 'detail'] as const,
  detail: (id: string) => [...domainsKeys.details(), id] as const,
};
